import { useState } from 'react'

import { useMutation } from '@tanstack/react-query'

import { useLegacyPublicApi } from '@/services/api/ApiContext'
import { VERIFY_ACCOUNT } from '@/services/endpoints'

import { useErrorHandler } from './useErrorHandler'

export const useVerifyAccount = ({ token, config = {} }) => {
  const api = useLegacyPublicApi()

  const [error, setError] = useState(null)
  const resolvedError = useErrorHandler(error)

  const {
    mutateAsync: mutate,
    isLoading,
    isSuccess,
  } = useMutation({
    mutationFn: async (data) => {
      if (!token) return false

      const payload = {
        token,
        password: data.password,
        newPassword: data.newPassword,
      }

      return await api.post(VERIFY_ACCOUNT, payload)
    },
    onSuccess: () => {
      setError(null)
    },
    onError: (error) => {
      setError(error)
    },
    ...config,
  })

  const verifyAccount = (data) => mutate(data)

  return {
    verifyAccount,
    isLoading,
    isSuccess,
    error: resolvedError,
  }
}
